<template>
  <customModal :containermd="true" @closeModal="$emit('close')">
    <template #title>
      {{ tableName }}
    </template>

    <template #body>
      <div class="modal-scroll-body">
        <div v-if="tableLoading" class="d-flex justify-content-center align-items-center py-5">
          <div class="spinner-border text-primary" role="status" aria-label="Loading"></div>
        </div>
        <div v-else>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead class="table-light">
                <tr>
                  <th>
                    Sequence No
                  </th>
                  <th>
                    <div class="d-flex flex-row justify-content-between">
                      AE Term
                    </div>
                  </th>
                  <th v-if="fromPage != 'subjectprofile'">
                    Subject Id
                  </th>
                  <th v-if="fromPage != 'subjectprofile'">
                    Site Code
                  </th>
                  <th>
                    CTCAE Grade
                  </th>
                  <th>
                    <div class="d-flex flex-row justify-content-between">
                      Causality
                    </div>
                  </th>
                  <th>
                    Serious
                  </th>
                  <th>
                    Duration
                  </th>
                  <th>
                    Start Date
                  </th>
                  <th>
                    End Date
                  </th>
                  <th>
                    Outcome
                  </th>
                  <th>
                    View
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in tableData" :key="item.id">
                  <td>{{ item.sequence }}</td>
                  <td>{{ item.term }}</td>
                  <td v-if="fromPage != 'subjectprofile'">{{ item.subjectId }}</td>
                  <td v-if="fromPage != 'subjectprofile'">{{ item.siteCode }}</td>
                  <td>{{ item.grade }}</td>
                  <td>{{ item.causality }}</td>
                  <td>{{ item.serious }}</td>
                  <td>{{ item.duration }}</td>
                  <td>{{ formatdatetime(item.startDate) }}</td>
                  <td>{{ formatdatetime(item.endDate) }}</td>
                  <td>{{ item.outcome }}</td>
                  <td class="text-center">
                    <i
                      class="fa fa-eye editicon"
                      @click.prevent="viewforms(item.id)"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row mx-0 mt-2" v-if="aeTimelineTotalPages > 1">
            <div class="col-lg-12 mx-0 px-0">
              <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                  <v-pagination
                    v-model="aeTimelineCurrentPage"
                    :pages="aeTimelineTotalPages"
                    :range-size="1"
                    active-color="#618bd7"
                    @update:modelValue="loadAeTimelinePage"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </customModal>
</template>
<script src="./aetablemodel.js"></script>
